"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrubApmPayload = scrubApmPayload;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _redactTelemetryText = require("./redactTelemetryText");
var _scrubTelemetryUrl = require("./scrubTelemetryUrl");
/**
 * Elastic APM RUM payload filter. Runs on every `{ transactions, errors }` batch just
 * before it is sent, covering page url/referer, transaction & span names, span `http.url`, tags,
 * error messages, culprit, stack frames and custom context. Mutates in place (the agent builds
 * fresh objects per send) and never throws.
 *
 * NOTE: metadata labels (`addLabels`) are built AFTER filters run and cannot be scrubbed here —
 * see `sanitizeExtraData` in src/services/logger.ts.
 */

var MAX_DEPTH = 8;
var URL_KEYS = new Set(['url', 'referer', 'referrer', 'href', 'abs_path', 'filename', 'culprit']);
// Keys holding ids/enums the agent generates itself — skipped for speed.
var SKIPPED_KEYS = new Set(['id', 'trace_id', 'parent_id', 'transaction_id', 'type', 'subtype', 'outcome', 'sampled']);

// A whole value that is one URL, optionally after an HTTP method — e.g. resource span names
// (`https://pixel.quantserve.com/pixel;...;url=...`) and external span names (`GET https://...`).
var WHOLE_URL_VALUE = /^((?:[A-Z]{3,7} )?)((?:https?|wss?):\/\/\S+)$/;
function isUrlKey(key) {
  var lowerKey = key.toLowerCase();
  return URL_KEYS.has(lowerKey) || lowerKey.endsWith('url');
}
function scrubString(key, value) {
  if (isUrlKey(key)) return (0, _scrubTelemetryUrl.scrubTelemetryUrl)(value);
  // Scrubbing the whole value as a URL avoids relying on URL-in-text detection, which can stop
  // early at characters like `'` inside third-party pixel params ("Let's%20Web...").
  var wholeUrl = WHOLE_URL_VALUE.exec(value);
  if (wholeUrl) return "".concat(wholeUrl[1]).concat((0, _scrubTelemetryUrl.scrubTelemetryUrl)(wholeUrl[2]));
  return (0, _scrubTelemetryUrl.scrubUrlsInText)(value);
}
function scrubEntry(node, key, depth) {
  var value = node[key];
  if (value == null || SKIPPED_KEYS.has(key)) return;
  if ((0, _redactTelemetryText.isSensitiveKey)(key)) {
    if (value !== '') node[key] = _redactTelemetryText.REDACTED;
  } else if (typeof value === 'string') {
    node[key] = scrubString(key, value);
  } else if ((0, _typeof2.default)(value) === 'object') {
    // eslint-disable-next-line no-use-before-define -- scrubNode and scrubEntry are mutually recursive
    if (depth < MAX_DEPTH) scrubNode(value, depth + 1);else node[key] = _redactTelemetryText.REDACTED;
  }
}
function scrubNode(node, depth) {
  for (var _i = 0, _Object$keys = Object.keys(node); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    try {
      scrubEntry(node, key, depth);
    } catch (_unused) {
      try {
        node[key] = _redactTelemetryText.REDACTED;
      } catch (_unused2) {
        // Non-writable field — nothing more we can do for it.
      }
    }
  }
}
function scrubApmPayload(payload) {
  try {
    for (var _i2 = 0, _arr = [payload === null || payload === void 0 ? void 0 : payload.transactions, payload === null || payload === void 0 ? void 0 : payload.errors]; _i2 < _arr.length; _i2++) {
      var events = _arr[_i2];
      if (Array.isArray(events)) events.forEach(function (event) {
        return event && scrubNode(event, 0);
      });
    }
    return payload;
  } catch (_unused3) {
    // Dropping one batch is an observability gap; sending it unscrubbed would be a leak.
    return;
  }
}